<template>
  <SystemLayout>
    <router-view />
  </SystemLayout>
</template>

<script>
import SystemLayout from '@/module/layouts/SystemLayout'

export default {
  components: {
    SystemLayout
  }
}
</script>

<style scoped>

</style>
